import { useSelector } from "react-redux"
import styled from "styled-components"
import ReturnGaragesList from "../partContainer/ReturnGaragesList"
import TopMenus from "../../shared/TopMenus"
import { useDispatch } from "react-redux"
import { setExtraResultActiveTab } from "../../../features/nakliyeHesaplama/nakliyeHesaplamaSlice"
import { useEffect, useState } from "react"
import SeraGazResult from "../partContainer/SeraGazResult"

const Container = styled.div`
    width: 100%;
    height: ${({isCenterResultContainerOpen}) => isCenterResultContainerOpen ? "350px" : 0};
    border-top: 1px solid ${({theme}) => theme.mainTextColor};
    overflow: auto;

    display: flex;
    flex-direction: column;

    .tab-container{
        margin: 20px;
        margin-top: 10px;
        margin-bottom: 0;
        width: 500px;
    }

    .content-container{
        width: 100%;
        height: 100%;
    }

`

const tabList = [
    {
        id:1,
        text: "Dönüş yükü için yakın garajlar"
    },
    {
        id:2,
        text: "Toplam Sera Gazı Emisyonu"
    },
]
const ExtraResultContainer = () => {

    const {
        isCenterResultContainerOpen,
        extraResultActiveTab,
        resCostData
    } = useSelector(state => state.nakliyeHesaplama)

    const [activeMenu, setActiveMenu] = useState(extraResultActiveTab)

    useEffect(() => {
        dispatch(setExtraResultActiveTab(activeMenu))
    },[activeMenu])

    const dispatch = useDispatch()

  return (
    <Container isCenterResultContainerOpen={isCenterResultContainerOpen && resCostData?.midCost}>
        <div className="tab-container">
        <TopMenus menuList={tabList} activeMenuId={extraResultActiveTab} setActiveMenuId={setActiveMenu}/>
        </div>


        <div className="content-container">
            {
                extraResultActiveTab === 1 &&
                <ReturnGaragesList/>
            }

            {
                extraResultActiveTab === 2 &&
                <SeraGazResult/>
            }
        </div>
    </Container>
  )
}

export default ExtraResultContainer